import script from "./AppointmentDataFileTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentDataFileTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentDataFileTableRow.vue?vue&type=style&index=0&id=882c2874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-882c2874"]])

export default __exports__